import { gql } from '@apollo/client'

export const BUSINESS_PROCESSES_TREE_UPDATE_MUTATION = gql`
  mutation BUSINESS_PROCESSES_TREE_UPDATE_MUTATION($businessProcesses: [BusinessProcessesTreeUpdateInput]!) {
    businessProcessesTreeUpdate(businessProcesses: $businessProcesses) {
      ok
    }
  }
`

export const BUSINESS_PROCESSES_DELETE_MUTATION = gql`
  mutation BUSINESS_PROCESSES_DELETE_MUTATION($id: ID!) {
    businessProcessDelete(id: $id) {
      ok
    }
  }
`

export const BUSINESS_PROCESS_UPDATE_MUTATION = gql`
  mutation BUSINESS_PROCESS_UPDATE_MUTATION($id: ID!, $businessProcess: BusinessProcessUpdateInput!) {
    businessProcessUpdate(id: $id, businessProcess: $businessProcess) {
      ok
    }
  }
`

export const BUSINESS_PROCESS_CREATE_MUTATION = gql`
  mutation BUSINESS_PROCESS_CREATE_MUTATION($businessProcess: BusinessProcessCreateInput!) {
    businessProcessCreate(businessProcess: $businessProcess) {
      ok
    }
  }
`
